import http from "@/http-common";

class UserApprovalDataService {
  getUserApprovalInfo(data: any): Promise<any> {
    return http.api.post("/getUserApprovalInfo/", data);
  }
  approveUserPermission(data: any): Promise<any> {
    return http.api.post("/approveUserPermission/", data);
  }
  denyUserPermission(data: any): Promise<any> {
    return http.api.post("/denyUserPermission/", data);
  }
  reAppUserPermissionData(data: any, data1: any, data2: any): Promise<any> {
    const param = { usrID: data, chkFlg: data1, stationCd: data2 };
    return http.api.post("/reAppUserPermission/", param);
  }
  checkUser(data: any): Promise<any> {
    return http.api.post("/chkUserType/", data);
  }
  insertTempUserData(data: any): Promise<any> {
    return http.api.post("/insertTempUserInfo/", data);
  }
  checkAuthUser(data: any): Promise<any> {
    return http.api.post("/checkAuthUser/", data);
  }
  checkAuthUserByEmail(data: any): Promise<any> {
    return http.api.post("/checkAuthUserByEmail/", data);
  }
}
export default new UserApprovalDataService();
